import REGEX from "Constants/regex.constants";

class PricelistTableHelper {
  formatDay(date) {
    const dayToBeFormated = new Date(date).getDate();
    return dayToBeFormated < 10 ? "0" + dayToBeFormated : dayToBeFormated;
  }

  formatMonth(date) {
    const monthToBeFormated = new Date(date).getMonth() + 1;
    return monthToBeFormated < 10 ? "0" + monthToBeFormated : monthToBeFormated;
  }

  formatYear(date) {
    const yearToBeFormated = new Date(date);
    return yearToBeFormated.getFullYear();
  }

  prepareDatesAndRoomTypes(data) {
    const [dates, roomTypes] = this.getDatesAndRoomTypes(data);
    return [dates, this.sortRoomTypes(roomTypes)];
  }

  getDatesAndRoomTypes(dates) {
    const datesAndRoomTypes = dates.reduce(
      (arr, cur) => {
        const date = `${this.formatDay(cur.depDate)}.${this.formatMonth(
          cur.depDate
        )}.${this.formatYear(cur.depDate)} - ${this.formatDay(
          cur.arrDate
        )}.${this.formatMonth(cur.arrDate)}.${this.formatYear(cur.arrDate)}`;

        arr[0].push(date);
        arr[1].push(cur.roomType);
        return arr;
      },
      [[], []]
    );
    const uniqueDates = new Set(datesAndRoomTypes[0]);
    const uniqueRoomTypes = new Set(datesAndRoomTypes[1]);

    return [Array.from(uniqueDates), Array.from(uniqueRoomTypes)];
  }

  sortRoomTypes(roomTypes) {
    return roomTypes.sort((a, b) => {
      let numb1 = a.match(REGEX.DIGIT);
      if (numb1 && numb1.length > 0) numb1 = numb1.join("");
      else return a >= b ? 1 : -1;

      let numb2 = b.match(REGEX.DIGIT);

      if (numb2 && numb2.length > 0) numb2 = numb2.join("");
      else return a >= b ? 1 : -1;

      if (numb1.length < numb2.length) {
        numb2 = numb2.substring(0, numb1.length);
        return numb1 >= numb2 ? 1 : -1;
      } else {
        numb1 = numb1.substring(0, numb2.length);
        return numb1 >= numb2 ? 1 : -1;
      }
    });
  }

  prepareColumns(dates) {
    return [
      {
        label: "#",
        field: "id",
        sort: "asc"
      },
      ...dates.map((date) => ({ label: date, field: date, sort: "asc" }))
    ];
  }

  prepareRows(roomTypes, dates) {
    return roomTypes.reduce((arr, cur) => {
      let obj = {
        id: cur
      };
      dates.forEach((d) => {
        if (d.roomType === cur) {
          const date = `${this.formatDay(d.depDate)}.${this.formatMonth(
            d.depDate
          )}.${this.formatYear(d.depDate)} - ${this.formatDay(
            d.arrDate
          )}.${this.formatMonth(d.arrDate)}.${this.formatYear(d.arrDate)}`;

          obj = { ...obj, [date]: d.price, [date + "const"]: d.const };
        }
      });
      arr.push(obj);
      return arr;
    }, []);
  }

  prepareRowsForRender(dates, rows, num) {
    return rows.map((row) => {
      let obj = {
        id: row.id
      };
      dates.forEach((date) => {
        if (!row[date])
          obj = {
            ...obj,
            [date]: "-"
          };
        else
          obj = {
            ...obj,
            [date]: row[date + "const"]
              ? Number(row[date])
              : Number(row[date]) + num
          };
      });

      return obj;
    });
  }
}

const pricelistTableHelper = new PricelistTableHelper();

export default pricelistTableHelper;
